<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h5 class="text-xs tracking-wide font-medium uppercase text-gray-400">Products</h5>
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Memberships
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <BaseButton
              primary
              tag="router-link"
              :to="{ name: 'admin.products.memberships.create' }"
              >New Membership</BaseButton
            >
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <BaseDataIterator :service="fetchProducts" disable-search>
          <!-- props
            data, fetchList
          -->
          <template #default="dataIteratorProps">
            <BaseDataTable :data="dataIteratorProps.data">
              <template #default="{ item }">
                <MembershipProductRow :product="item" @deleted="dataIteratorProps.fetchList" />
              </template>
            </BaseDataTable>
          </template>
        </BaseDataIterator>
      </div>
    </div>
  </div>
</template>

<script>
import { membershipProductsClient } from '@/api/clients/admin';
import MembershipProductRow from './components/MembershipProductRow.vue';

export default {
  components: {
    MembershipProductRow,
  },
  data() {
    return {
      products: [],
    };
  },
  methods: {
    fetchProducts(params = {}) {
      return membershipProductsClient.list({
        ...params,
        include: 'media',
      });
    },
  },
};
</script>
